import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { OrderCard } from "@/components/OrderCard";
import { Spinner } from "@/components/ProtectedRoute";

export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    api.get("/admin/orders").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, []);
  if (!orders) return <Spinner />;
  if (orders.length === 0) {
    return <div data-testid="admin-orders-empty" className="card-mc p-8 text-center text-sm text-muted-foreground">Nessun ordine pagato per ora.</div>;
  }
  return (
    <div data-testid="admin-orders-list" className="space-y-4">
      {orders.map((o) => (
        <OrderCard key={o.id} o={o} admin
          onDeleted={(id) => setOrders((cur) => cur.filter((x) => x.id !== id))}
          onUpdated={(u) => setOrders((cur) => cur.map((x) => (x.id === u.id ? u : x)))} />
      ))}
    </div>
  );
}
